export default __webpack_public_path__ + "static/media/PlanetsPRO.7a6427c4.jpg";